var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "pega-break" }, [
    _c("div", { staticClass: "boss-table-title pega-print-title" }, [
      _c("div", { staticClass: "pega-ta-right" }, [
        _c("span", { attrs: { "data-test": "label-company-name" } }, [
          _vm._v(_vm._s(_vm.entryCompanyName) + "\n        "),
          _vm.headerUserName
            ? _c("span", { attrs: { "data-test": "header-info" } }, [
                _c("br"),
                _vm.isDuplicatedEntries
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "boss-status-label pega-status-label pega-status-label-top-0",
                        attrs: { "data-test": "label-duplicated-entries" },
                      },
                      [_vm._v("重複応募\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isSimpleEntryForm
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "boss-status-label pega-status-label pega-status-label-top-0",
                        attrs: { "data-test": "label-entry-form" },
                      },
                      [_vm._v("自己PR不要\n          ")]
                    )
                  : _vm._e(),
                _vm._v(
                  "\n          応募者：" +
                    _vm._s(_vm.headerUserName) +
                    "様\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _c("span", { attrs: { "data-test": "label-resume-updated-at" } }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm._f("parseDate")(_vm.resumeUpdatedAt)) +
                "現在\n        "
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "boss-layout-block" }, [
      _c(
        "table",
        {
          staticClass:
            "boss-table-4 boss-table-4-responsive pega-th-color-important pega-resume",
        },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v("直近の経験職種")]),
            _vm._v(" "),
            _c("td", [
              _c("span", { attrs: { "data-test": "text-recent-occupation" } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("parseText")(_vm.recentOccupation, "", "")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v("経験職種")]),
            _vm._v(" "),
            _c(
              "td",
              [
                _vm.isSimpleEntryForm
                  ? _c("hidden-notice", {
                      attrs: {
                        "data-test": "text-experienced-occupations-simple-form",
                      },
                    })
                  : _c("span", {
                      attrs: { "data-test": "text-experienced-occupations" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.parseText(
                            _vm.experiencedOccupationsText
                          )
                        ),
                      },
                    }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass:
            "boss-table-4 boss-table-4-responsive pega-th-color-important pega-resume",
        },
        [
          _vm._m(2),
          _vm._v(" "),
          _vm._l(_vm.careers, function (career, i) {
            return [
              _c("tr", { key: "outline-overview-" + i }, [
                _c(
                  "th",
                  { attrs: { "data-test": "head-career-" + i, rowspan: "4" } },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.workingPeriod(career)) +
                        "\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "boss-table-4-cell-group-top",
                    attrs: {
                      "data-test": "text-career-outline-" + i,
                      colspan: "2",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(career.companyName) +
                        " " +
                        _vm._s(
                          _vm._f("parseText")(
                            career.businessCategory,
                            "業種",
                            ""
                          )
                        ) +
                        "（従業員数" +
                        _vm._s(
                          _vm._f("parseText")(career.employees, "", "名")
                        ) +
                        "） " +
                        _vm._s(
                          _vm._f("parseText")(
                            career.employmentStatus,
                            "雇用形態"
                          )
                        ) +
                        _vm._s(_vm._f("parseDispatchCompanyName")(career)) +
                        " 年収" +
                        _vm._s(_vm._f("parseText")(career.salary, "", "万円"))
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("tr", { key: "outline-business-" + i }, [
                _c(
                  "th",
                  {
                    staticClass: "sub",
                    attrs: { "data-test": "head-career-business-content-" + i },
                  },
                  [
                    _vm._v("\n            事業内容\n            "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content:
                                "事業内容の説明、所属部署、支店の説明など",
                            },
                            expression:
                              "{ content: '事業内容の説明、所属部署、支店の説明など'}",
                          },
                        ],
                        staticClass: "pega-circle",
                      },
                      [_vm._v("?")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("td", {
                  staticClass: "pega-pre-wrap",
                  attrs: { "data-test": "text-career-business-content-" + i },
                  domProps: {
                    textContent: _vm._s(
                      _vm.$options.filters.parseText(career.descriptionTxt1)
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("tr", { key: "outline-job-" + i }, [
                _c(
                  "th",
                  {
                    staticClass: "sub",
                    attrs: { "data-test": "head-career-job-content-" + i },
                  },
                  [
                    _vm._v("\n            仕事内容\n            "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: { content: "具体的な仕事内容、役割など" },
                            expression:
                              "{ content: '具体的な仕事内容、役割など'}",
                          },
                        ],
                        staticClass: "pega-circle",
                      },
                      [_vm._v("?")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("td", {
                  staticClass: "pega-pre-wrap",
                  attrs: { "data-test": "text-career-job-content-" + i },
                  domProps: {
                    textContent: _vm._s(
                      _vm.$options.filters.parseText(career.descriptionTxt2)
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("tr", { key: "outline-skill-" + i }, [
                _c(
                  "th",
                  {
                    staticClass: "sub",
                    attrs: { "data-test": "head-career-skill-content-" + i },
                  },
                  [_vm._v("成果・経験")]
                ),
                _vm._v(" "),
                _c("td", {
                  staticClass: "pega-pre-wrap",
                  attrs: { "data-test": "text-career-skill-content-" + i },
                  domProps: {
                    textContent: _vm._s(
                      _vm.$options.filters.parseText(career.descriptionTxt3)
                    ),
                  },
                }),
              ]),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass:
            "boss-table-4 boss-table-4-responsive pega-th-color-important pega-resume",
        },
        [
          _vm._m(3),
          _vm._v(" "),
          _vm._l(_vm.skillsMaster, function (master) {
            return _c("tr", { key: master.id }, [
              _c("th", { attrs: { "data-test": "head-skills-" + master.id } }, [
                _vm._v("\n          " + _vm._s(master.name) + "\n        "),
              ]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { "data-test": "detail-skills-" + master.id } },
                [
                  _vm.isSimpleEntryForm
                    ? _c("hidden-notice")
                    : [
                        _vm.layeredSkillsByLv2Category[master.id].length
                          ? [
                              _vm._l(
                                _vm.layeredSkillsByLv2Category[master.id],
                                function (skillL2CategoryAndSkillDetails, i) {
                                  return [
                                    _vm.hasChildCategorySkillBy(master.id)
                                      ? _c(
                                          "p",
                                          {
                                            key: master.id + "-" + i,
                                            staticClass: "boss-text",
                                            attrs: {
                                              "data-test":
                                                "label-skills-category-" +
                                                master.id +
                                                "-" +
                                                i,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "[" +
                                                _vm._s(
                                                  skillL2CategoryAndSkillDetails[0]
                                                ) +
                                                "]"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "dl",
                                      {
                                        key: "dl-" + master.id + "-" + i,
                                        staticClass: "boss-definition-list",
                                      },
                                      _vm._l(
                                        skillL2CategoryAndSkillDetails[1],
                                        function (detail, j) {
                                          return _c(
                                            "dd",
                                            {
                                              key:
                                                master.id + "-" + i + "-" + j,
                                              attrs: {
                                                "data-test":
                                                  "text-skills-" +
                                                  master.id +
                                                  "-" +
                                                  i +
                                                  "-" +
                                                  j,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm._f("parseSkillDetail")(
                                                      detail
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                }
                              ),
                            ]
                          : [_vm._v("\n              未登録\n            ")],
                      ],
                ],
                2
              ),
            ])
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-layout boss-layout-gap-between" }, [
      _c("div", [
        _c("div", { staticClass: "boss-resume-sheet-title" }, [
          _vm._v("職務経歴書"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c(
        "td",
        {
          staticClass: "boss-table-4-space boss-table-4-space-title",
          attrs: { colspan: "5" },
        },
        [_vm._v("経験職種")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c(
        "td",
        {
          staticClass: "boss-table-4-space boss-table-4-space-title",
          attrs: { colspan: "5" },
        },
        [_vm._v("職務経歴")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c(
        "td",
        {
          staticClass: "boss-table-4-space boss-table-4-space-title",
          attrs: { colspan: "5" },
        },
        [_vm._v("スキル・経験")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }